export default __webpack_public_path__ + "static/media/Alexis-Ohanian.2ec97394.png";